import { Component, OnInit } from "@angular/core";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { AdminService } from "../admin.service";
import { MatSnackBar } from "@angular/material/snack-bar";

@Component({
  selector: "app-admin-settings",
  templateUrl: "./admin-settings.component.html",
  styleUrls: ["./admin-settings.component.css"],
})
export class AdminSettingsComponent implements OnInit {
  // timeControl = new FormControl("30:00", [
  //   Validators.pattern(/^(?:[0-5]?[0-9]):[0-5][0-9]$/), // MM:SS format
  // ]);

  token: any;
  loading: boolean = false;
  settingForm!: FormGroup;

  constructor(
    private fb: FormBuilder,
    private services: AdminService,
    private snackBar: MatSnackBar
  ) {
    // this.timeControl.valueChanges.subscribe((value) => {
    //   if (value && this.validateAndFormatTime(value)) {
    //     this.timeControl.setValue(this.validateAndFormatTime(value), {
    //       emitEvent: false,
    //     });
    //   }
    // });
  }
  private validateAndFormatTime(value: string): string | null {
    // Allow only digits and colon
    value = value.replace(/[^0-9:]/g, "");

    // Format as MM:SS if entering without colon
    if (value.length === 2 && !value.includes(":")) {
      return `${value}:`;
    }

    // Restrict to MM:SS format
    const parts = value.split(":");
    const minutes = parts[0] ? parts[0].slice(0, 2) : "";
    const seconds = parts[1] ? parts[1].slice(0, 2) : "";

    // Only allow 0-59 for minutes and seconds
    if (minutes && +minutes > 59) return null;
    if (seconds && +seconds > 59) return `${minutes}:59`;

    return `${minutes}${seconds ? ":" + seconds : ""}`;
  }

  ngOnInit(): void {
    this.token = localStorage.getItem("adminToken");
    this.settingGet();
    this.settingForm = this.fb.group({
      corporate_push_notification_default_timer: [
        "",
        [Validators.pattern(/^\d{1,3}$/)],
      ],
      corporate_ranking_timer: [
        "",
        [Validators.pattern(/^\d{1,3}$/)],
      ],
      quote_expiry_time: [
        "",
        [Validators.pattern(/^\d{1,3}$/)],
      ],
      corporate_push_notification_margin: [
        "",
        [Validators.pattern(/^\d{1,3}$/)],
      ],
      corporate_push_notification: [true],
      corporate_sms_notification: [true],
    });
  }

  formatTime(event: Event, controlName: string): void {
    const input = event.target as HTMLInputElement;
    const value = input.value.replace(/[^0-9]/g, ""); // Remove non-numeric characters

    input.value = value; // Reflect cleaned value in UI
    this.settingForm.get(controlName)?.setValue(value, { emitEvent: false });
  }

  isValidTimer(): boolean {
    const control = this.settingForm.get(
      "corporate_push_notification_default_timer"
    );
    return control?.valid || !control?.touched;
  }

  restrictToNumbers(event: Event): void {
    const input = event.target as HTMLInputElement;
    input.value = input.value.replace(/[^0-9]/g, ""); // Remove non-numeric characters
    this.settingForm
      .get("corporate_push_notification_margin")
      ?.setValue(input.value, {
        emitEvent: false,
      });
  }

  isMarginValid(): boolean {
    const control = this.settingForm.get("corporate_push_notification_margin");
    return control?.valid || !control?.touched;
  }

  settingGet() {
    this.loading = true;

    this.services.settingsList(this.token).subscribe(
      (response: any) => {
        // Check if response contains valid data
        if (
          response &&
          response.body &&
          response.body.record &&
          response.body.record.length > 0
        ) {
          // Patch the API data into the form
          this.settingForm.patchValue(response.body.record[0]);
        }
        this.loading = false;
      },
      (error) => {
        console.error("Error fetching settings:", error);
        this.loading = false;
      }
    );
  }
  
  updateSettings() {
    const pushTimer = Number(this.settingForm.value.corporate_push_notification_default_timer);
    const rankingTimer = Number(this.settingForm.value.corporate_ranking_timer);
    const quote_expiry_time = Number(this.settingForm.value.quote_expiry_time);
    // Validate push notification timer
    if (pushTimer < 1) {
      this.snackBar.open("Push Notification Timer cannot be less than 1", "Close", {
        duration: 3000,
        panelClass: ["error-snackbar"],
      });
      return;
    }
    // Validate ranking timer
    if (rankingTimer < 1) {
      this.snackBar.open("Ranking Timer cannot be less than 1", "Close", {
        duration: 3000,
        panelClass: ["error-snackbar"],
      });
      return;
    }
    // Validate Quote Expiry time
    if (quote_expiry_time < 1) {
      this.snackBar.open("Quote Expiry Time cannot be less than 1", "Close", {
        duration: 3000,
        panelClass: ["error-snackbar"],
      });
      return;
    }
    this.loading = true;
    const data = {
      corporate_push_notification_default_timer: pushTimer,
      corporate_ranking_timer: rankingTimer,
      quote_expiry_time,
      corporate_push_notification_margin: this.settingForm.value.corporate_push_notification_margin,
      corporate_push_notification: this.settingForm.value.corporate_push_notification,
      corporate_sms_notification: this.settingForm.value.corporate_sms_notification,
    };
    this.services.settingsAdd(data, this.token).subscribe((response: any) => {
      console.log("response", response);
      this.settingGet();
      this.loading = false;
    });
  }
}
